import { useLoaderData, useLocation } from 'react-router';
import { InvoiceTable } from '../../../../../components/Invoices/Invoices';
import { DEFAULT_ITEMS_PER_PAGE, ListPagination, ListSearch } from '../../../../../components/Table';
import { setDefaultItemsPerPage } from '../../../../../components/Table/tableUtils';
import { useAuth } from '../../../AuthProvider';
import type { BillingAccountInvoicesData } from '../../../../../common/loaders';

export const BillingAccountInvoicesPath = () => {
  const { invoices } = useLoaderData() as BillingAccountInvoicesData;
  const { authenticatedUser } = useAuth();
  const { search } = useLocation();

  return (
    <div className="of-billing-account-invoices-list">
      <ListSearch onSearch={() => setDefaultItemsPerPage(new URLSearchParams(search), DEFAULT_ITEMS_PER_PAGE)} />
      <InvoiceTable
        invoices={invoices.searchResults ?? []}
        authenticatedUser={authenticatedUser}
        search={search}
        tableColumns={['invoiceDisplayId', 'payerName', 'due', 'sum', 'state']}
      />
      <ListPagination totalItems={invoices.total} />
    </div>
  );
};
